import React, { Component } from "react";
import FormCore from "@/components/display/form/formCore";
import fetchHandler from "@/fetch/fetchHandler";
import PropTypes from "prop-types";
import RefreshGrid from "@/utils/refreshGrid";

// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { getPermissionList, editRole } from "../../../fetch/fetchApi";

// eslint-disable-next-line arrow-parens
@connect(state => state)
class EditRoleModal extends Component {
  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.editRoleModal;
    this.state = {};
  }

  componentWillMount() {
    this.synData();
  }

  synData() {
    this.modalParams = this.context.store.getState().modalInfo.param;
    // this.context.store.getState().modalInfo.param.defaultTarget
    // = this.props.roleData.defaultTarget;
    this.setState({
      formConfig: {
        childItems: [
          {
            type: "input", // 定义表单元素基础类型
            inputType: "text", // 定义表单元素的子类型
            param: {
              // 定义表单元素的参数对象
              name: "name", // 参数名称
              type: "string", // 参数类型，用来做类型检测
            },
            validator: {
              // 自定义校验对象
              vtype: "length", // 校验名称
              min_val: 1, // 规则参数
              max_val: 20,
            },
            labelName: this.internationalization.title1, // '角色名称', // label名称
            required: !0,
            defaultValue: this.modalParams.name || "", // 设置默认值，同设置disabled则不能修改
            placeholder: this.internationalization.placeholder1, // '请输入角色名称'
          },
          {
            type: "transfer",
            transType: "default",
            titles: [this.internationalization.choose1, this.internationalization.choose2],
            placeholder: this.internationalization.placeholder2, // '请输入搜索内容',
            nofound: this.internationalization.msg1, // '暂无选项',
            itemUnit: this.internationalization.dw1, // '项',
            // 通过参数key来配置source和target
            key: ["soureData", "defaultTarget"],
            param: {
              name: "permissionIds",
              type: "array",
            },
          },
          {
            type: "buttonGp", // 表单最终执行组
            buttonArr: [
              {
                btnType: "submit",
                text: this.internationalization.btn1, // '确定'
              },
              // {
              //   btnType: 'reset',
              //   text: '清空'
              // }
            ],
          },
        ],
        layout: "horizontal", // 设置布局 0： 横向布局， 1：纵向布局
        formTarget: "submit", // 表单提交类型，设置grid则为更新grid
        autoLoadGrid: !1, // 设置为false不触发加载grid
        context: this,
      },
    });
    this.getPermissionList().then(() => {
      this.setState({
        formConfig: {
          childItems: [
            {
              type: "input", // 定义表单元素基础类型
              inputType: "text", // 定义表单元素的子类型
              param: {
                // 定义表单元素的参数对象
                name: "name", // 参数名称
                type: "string", // 参数类型，用来做类型检测
              },
              labelName: this.internationalization.title2, // '角色名称', // label名称
              required: !0,
              defaultValue: this.modalParams.name || "", // 设置默认值，同设置disabled则不能修改
              placeholder: this.internationalization.placeholder3, // '请输入角色名称'
            },
            {
              type: "transfer",
              transType: "default",
              titles: [this.internationalization.choose1, this.internationalization.choose2],
              placeholder: this.internationalization.placeholder2, // '请输入搜索内容',
              nofound: this.internationalization.msg1, // '暂无选项',
              itemUnit: this.internationalization.dw1, // '项',
              // 通过参数key来配置source和target
              key: ["defaultSource", "defaultTarget"],
              param: {
                name: "permissionIds",
                type: "array",
              },
            },
            {
              type: "buttonGp", // 表单最终执行组
              buttonArr: [
                {
                  btnType: "submit",
                  text: this.internationalization.btn1, // '确定'
                },
                // {
                //  btnType: 'reset',
                //  text: '清空'
                // }
              ],
            },
          ],
          layout: "horizontal", // 设置布局 0： 横向布局， 1：纵向布局
          formTarget: "submit", // 表单提交类型，设置grid则为更新grid
          autoLoadGrid: !1, // 设置为false不触发加载grid
          context: this,
        },
      });
    });
  }

  async getPermissionList() {
    try {
      const resData = await getPermissionList();
      const formatBeforeData = resData.data.data;
      const fromData = JSON.parse(
        JSON.stringify(formatBeforeData)
          .replace(/id/g, "key")
          .replace(/childList/g, "children")
          .replace(/name/g, "title"),
      );
      this.context.store.getState().modalInfo.param.defaultSource = fromData;
      return fromData;
    } catch (e) {
      console.debug(e);
    }
  }

  fetchApi = (result) => {
    if (this.state.formConfig.formTarget === "grid") {
      return;
    }
    // result.roleId = this.state.roleId;
    if (this.modalParams.roleId) {
      result.roleId = this.modalParams.roleId;
    }

    return fetchHandler(editRole, result).then((res) => {
      if (res.code === "success") {
        RefreshGrid(this.context.store, "roleListTable");
      }
    });
  }

  render() {
    return (
      <div>
        <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
      </div>
    );
  }
}

export default injectIntl(EditRoleModal);



// WEBPACK FOOTER //
// ./src/AntD/pages/system/role/editRoleModal.js